import { Injectable } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';

@Injectable({
	providedIn: 'root',
})
export class NavigationToolsService {
	private _isForceNavigating = false;

	constructor(private router: Router) {}

	public get isForceNavigating(): boolean {
		return this._isForceNavigating;
	}

	public tryForceNavigate = async (
		commands: readonly unknown[],
		extras?: NavigationExtras,
	): Promise<void> => {
		try {
			this._isForceNavigating = true;
			await this.router.navigate(commands, extras);
		} catch (e) {
			console.error(
				`NavigationToolsService: Failed to force navigate`,
				commands,
				extras,
				e,
			);
		}

		this._isForceNavigating = false;
	};
}
